// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3lBog","head":"Table_head__9h3-m","col":"Table_col__XaexB"};